import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Column, VideoModal, Button } from '@pella/sash-framework';
import { CTA, Image } from '../../';
import { initDataLayer } from '../../utilities/functions';
import { isValidArray } from '../../utilities/validations';

const PerformancePanel = ({ data, className }) => {
	const [modalOpen, setModalOpen] = useState(false);

	if (!data) return null;

	const renderPerformanceSections = (section, index) => (
		<div
			key={`performancePackages-section-${index}`}
			className='performancePackages-sectionFeature py-2.5 lg:py-11'
		>
			{section.file?.url && (
				<Image
					data={{ image: section.file }}
					className='[&_img]:max-h-[70px]'
				/>
			)}

			<h3 className='performancePackages-sectionHeading mb-3 mt-6 font-semibold text-white'>{section.heading}</h3>
			<div
				className='performancePackages-sectionDescription text-pretty text-xs text-neutral-200 md:text-base [&_a]:text-current [&_a]:decoration-current'
				dangerouslySetInnerHTML={{ __html: section.description }}
			/>
		</div>
	);

	return (
		<div
			id={data.anchor || null}
			className={`performancePackages bg-neutral-600 py-8 lg:py-14 lg:text-center ${className || ''}`}
			data-testid='performance-panel'
		>
			<Container>
				<div className='mb-6'>
					{data.heading && <h2 className='performancePackages-title text-white'>{data.heading}</h2>}

					{data.description && (
						<div
							className='performancePackages-intro mx-auto mt-6 max-w-[900px] text-sm leading-relaxed text-white md:text-lg [&_a]:text-current [&_a]:decoration-current'
							dangerouslySetInnerHTML={{ __html: data.description }}
						/>
					)}
				</div>

				{isValidArray(data?.sections) && (
					<Row
						align='center'
						className='justify-center lg:justify-between'
					>
						<Column
							xs={12}
							sm={8}
							lg={4}
						>
							{data.sections.filter((_, index) => index < 2).map((pack, index) => renderPerformanceSections(pack, index))}
						</Column>

						<Column
							xs={12}
							lg={3}
							className='performancePackages-imageCol text-center'
						>
							{data.cob?.url && (
								<Image
									data={{ image: data.cob }}
									className='performancePackages-mainImage my-5 lg:my-0'
								/>
							)}
						</Column>

						<Column
							xs={12}
							sm={8}
							lg={4}
						>
							{data.sections.filter((_, index) => index >= 2).map((pack, index) => renderPerformanceSections(pack, index))}
						</Column>
					</Row>
				)}

				{isValidArray(data?.cta) && (
					<div className='performancePackages-cta mt-12 md:mt-16'>
						<CTA data={data.cta[0]} />
					</div>
				)}

				{isValidArray(data?.video?.video) && data.video.cta_title && (
					<div className='performancePackages-videoBtnDiv mt-8 md:mt-10'>
						<Button
							color='primary'
							onClick={() => {
								setModalOpen(true);
								initDataLayer('videoplay');
							}}
							className='performancePackages-videoBtn mt-5 [&_img]:align-bottom'
						>
							{data.video.cta_title}
						</Button>

						<VideoModal
							isOpen={modalOpen}
							onClose={() => setModalOpen()}
							videoId={data.video.video[0].video.video_id}
							title={data.video.video[0].video.title}
							transcript={data.video.video[0].transcript}
						/>
					</div>
				)}
			</Container>
		</div>
	);
};

PerformancePanel.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
};

export default React.memo(PerformancePanel);
